import React from 'react';

const OldForecast = () => (
  <svg
    className="old_forecast_icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 42 27"
  >
    <g fill="#FFF" fillRule="evenodd">
      <path
        stroke="#FFF"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M41 24.308V26H21.001c-.115-5.198-4.204-9.375-9.232-9.375S2.652 20.802 2.537 26H1V1h40v23.308c-3.755 1.206-9.304.466-9.527-2.724-.294-4.21-5.657-.3-9.171-2.892-3.514-2.592 3.43-7.464.559-9.868-3.39-2.837-1.449-5.857.332-7.824h17.814v23.305a9.75 9.75 0 0 1-.007.003zm-29.23-7.683c2.55 0 4.616-2.149 4.616-4.8 0-2.65-2.067-4.8-4.617-4.8s-4.617 2.15-4.617 4.8c0 2.651 2.067 4.8 4.617 4.8z"
      />
      <path d="M40.948 5.328a4.485 4.485 0 0 0-.415-.248c-3.539-1.866-6.954-4.34-5.942-.45 1.012 3.888-2.899 5.997 0 7.099 2.899 1.102 2.533 1.755 5.942 1.896.147.006.285 0 .417-.017v5.649c-2.535.763-3.225-3.352-6.963-3.402-4.118-.055-5.91-1.543-4.908-4.418C30.597 7.08 27.212 3.814 29.077 1l11.87.002.001 4.326z" />
    </g>
  </svg>
);

export default OldForecast;
